import { render, staticRenderFns } from "./FaqCollapsible.vue?vue&type=template&id=fa71c85e&scoped=true&"
import script from "./FaqCollapsible.vue?vue&type=script&lang=js&"
export * from "./FaqCollapsible.vue?vue&type=script&lang=js&"
import style0 from "./FaqCollapsible.vue?vue&type=style&index=0&id=fa71c85e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa71c85e",
  null
  
)

export default component.exports